var _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.063,
    height: 25.968,
    viewBox: "0 0 28.063 25.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -19.114)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.299 40.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.124,402.828a2.468,2.468,0,1,0,2.468,2.468A2.471,2.471,0,0,0,172.124,402.828Zm0,3.558a1.09,1.09,0,1,1,1.09-1.09A1.091,1.091,0,0,1,172.124,406.386Z",
    transform: "translate(-169.656 -402.828)",
    fill: "#0080ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.956 40.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.069,402.828a2.468,2.468,0,1,0,2.468,2.468A2.471,2.471,0,0,0,330.069,402.828Zm0,3.558a1.09,1.09,0,1,1,1.09-1.09A1.091,1.091,0,0,1,330.069,406.386Z",
    transform: "translate(-327.601 -402.828)",
    fill: "#0080ff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.468 27.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.559,165.755h-9.874a.689.689,0,1,0,0,1.378h9.874a.689.689,0,1,0,0-1.378Z",
    transform: "translate(-190.996 -165.755)",
    fill: "#0080ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.006 30.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.29,231.035h-8.8a.689.689,0,0,0,0,1.378h8.8a.689.689,0,0,0,0-1.378Z",
    transform: "translate(-200.802 -231.035)",
    fill: "#0080ff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.753,24.082a1.372,1.372,0,0,0-1.068-.507H5.222l-.433-2.1a1.38,1.38,0,0,0-.8-.986L.963,19.171a.689.689,0,0,0-.549,1.264l3.024,1.313L6.773,37.932a1.383,1.383,0,0,0,1.35,1.1H24.63a.689.689,0,0,0,0-1.378H8.122l-.406-1.969h17.04a1.383,1.383,0,0,0,1.35-1.1l1.927-9.355A1.373,1.373,0,0,0,27.753,24.082Zm-3,10.225H7.433L5.506,24.952H26.685Z",
    transform: "translate(0 -19.114)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.c5c9b2c5.svg";
export { ForwardRef as ReactComponent };